import { clearLocations } from 'redux/modules/content/actions/clear-locations';
import { clearSearch } from 'redux/modules/search/actions/clear-search';

import getCmsPage from 'redux/modules/cms-page/actions/fetch-cms-page';
import { getCustomerId } from 'redux/modules/sessions/selectors';

export const cmsPageFetcher =
  ({ match: { pathname = '' } = {} } = {}) =>
  (dispatch, getState) => {
    const contentUrl = pathname.replace('/ecom/', '');
    const customerId = getCustomerId(getState());

    dispatch(clearSearch());
    dispatch(clearLocations());

    return dispatch(getCmsPage(contentUrl, customerId));
  };
